module.exports = __webpack_public_path__ + "img/c6a97db72c61a4e5b8697fd495465d06.png";